<template>
  <div class="document-template-workspace">
    <el-form
      ref="form"
      :model="templateData"
      label-width="100px"
      label-position="right"
      :show-message="false"
    >
      <!-- 顶部操作按钮 -->
      <div style="width:100%; min-width:1200px; margin-top: 20px; margin-bottom: 20px; padding-left: 20px;">
        <div v-if="isLook">
          <el-button type="primary" @click="$emit('back', false)">
            {{ $t('common.btn.back') }}
          </el-button>
          <el-button v-if="$checkPermission(['button_DocumentTemplateManagement_edit'])" type="success" @click="switchToEdit">
            {{ $t('common.btn.edit') }}
          </el-button>
          <el-button v-if="$checkPermission(['button_DocumentTemplateManagement_edit'])" type="primary" @click="switchToAdd">
            {{ $t('common.btn.new') }}
          </el-button>
          <el-button v-if="$checkPermission(['button_DocumentTemplateManagement_edit'])" :disabled="isEnableDisabled" type="primary" @click="enableFunction">
            {{ $t('common.btn.enable') }}
          </el-button>
          <el-button
            v-if="$checkPermission(['button_DocumentTemplateManagement_edit'])"
            :disabled="isDisableDisabled"
            type="danger"
            @click="disableFunction"
          >{{ $t('common.btn.disable') }}
          </el-button>
          <el-button
            v-if="$checkPermission(['button_DocumentTemplateManagement_edit'])"
            :disabled="isDeleteDisabled"
            type="danger"
            @click="deleteFunction"
          >{{ $t('common.btn.delete') }}
          </el-button>
        </div>
        <div v-else>
          <el-button type="success" @click="saveTemplate">
            {{ $t('common.btn.save') }}
          </el-button>
          <el-button @click="$emit('back', false)">
            {{ $t('common.btn.cancel') }}
          </el-button>
        </div>
      </div>

      <!-- 基本信息区域 -->
      <div class="section" style="width:100%; min-width:1200px">
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
          <span class="title">{{ $t('SystemMaintenance.DocumentInfo') }}</span>
          <div style="display: flex; align-items: center;">
            <span style="margin-right: 8px; color: #333; font-size: 16px; font-weight: bold;">{{ $t('CargoMsg.Cargo_Status') + ':' }}</span>
            <el-tag
              :type="'success'"
              size="medium"
              style="font-size: 14px; padding: 4px 12px;"
            >
              {{ getStatusLabel(templateData.status) }}
            </el-tag>
          </div>
        </div>
        <div class="form-row" style="display:flex;flex-direction:row;">
          <el-form
            label-width="100px"
            label-position="right"
            :disabled="isLook"
            style="margin-right:10px; width: 100%;"
          >
            <!-- 第一行：模板名称、本地化模板名称、适用港口、模板类型 -->
            <el-row :gutter="20" style="margin-bottom: 10px;">
              <el-col :span="6">
                <el-form-item :label="$t('SystemMaintenance.TemplateName')" prop="templateName" label-width="100px">
                  <el-input
                    v-model="templateData.templateName"
                    maxlength="100"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('SystemMaintenance.LocalizedTemplateName')" prop="localTemplateName" label-width="120px">
                  <el-input
                    v-model="templateData.localTemplateName"
                    maxlength="100"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('SystemMaintenance.ApplicableSeaport')" prop="applicableToSeaportCode" label-width="80px">
                  <cargo-advance-select
                    ref="applicableToSeaportCode"
                    no="applicableToSeaportCode"
                    :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                    :filter-tag-names="['code','englishName']"
                    :select-type="selectTypeNames.basic_data_Seaport"
                    filterable
                    :placeholder="' '"
                    :multiple="true"
                    :default-multiple-value="tempData.applicableToSeaportCodeArray"
                    @parentCallBack="p=>{tempData.applicableToSeaportCodeArray=p.value}"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('SystemMaintenance.TemplateType')" prop="templateType" label-width="80px">
                  <el-cascader
                    v-model="templateData.templateType"
                    :options="templateTypeTreeData"
                    :props="cascaderProps"
                    :placeholder="$t('Message.PleaseSelect')"
                    size="small"
                    clearable
                    filterable
                    :show-all-levels="true"
                    separator=" / "
                    @change="handleTemplateTypeChange"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第二行：模板描述、本地化模板描述、适用承运人、版本号（查看时） -->
            <el-row :gutter="20" style="margin-bottom: 10px;">
              <el-col :span="6">
                <el-form-item :label="$t('SystemMaintenance.TemplateDescription')" prop="templateDescription" label-width="100px">
                  <el-input
                    v-model="templateData.templateDescription"
                    type="textarea"
                    maxlength="500"
                    :rows="5"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('SystemMaintenance.LocalizedTemplateDescription')" prop="localTemplateDescription" label-width="120px">
                  <el-input
                    v-model="templateData.localTemplateDescription"
                    type="textarea"
                    maxlength="500"
                    :rows="5"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('SystemMaintenance.ApplicableCarrier')" prop="applicableCarrierId" label-width="80px">
                  <cargo-company-select
                    ref="shippingCompany"
                    no="carrierId"
                    :placeholder="' '"
                    :multiple="true"
                    :default-multiple-value="tempData.applicableCarrierIdArray"
                    :data-filter-function="customerIdFilter"
                    @change="p=>{tempData.applicableCarrierIdArray=p.value}"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item v-if="isLook" :label="$t('CargoMsg.Cargo_VersionNo')" prop="version" label-width="80px">
                  <el-input v-model="templateData.version" readonly size="small" />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第三行：修改时间（仅查看时显示） -->
            <el-row v-if="isLook" :gutter="20" style="margin-bottom: 10px;">
              <el-col :span="6">
                <!-- 空占位 -->
              </el-col>
              <el-col :span="6">
                <!-- 空占位 -->
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('SeaExport.DateModified')" prop="dateModified" label-width="100px">
                  <el-date-picker
                    v-model="templateData.dateModified"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    size="small"
                    readonly
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 空占位 -->
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <!-- 文档模板区域 -->
      <div class="section" style="width:100%; min-width:1200px">
        <span class="title">{{ $t('SystemMaintenance.DocumentTemplate') }}</span>
        <div class="form-row grid-list">
          <el-form
            label-width="100px"
            label-position="left"
            :disabled="isLook"
            style="margin-right:10px"
          >
            <el-form class="spacing">
              <!-- 选择文件和删除文件按钮只在新建编辑时显示 -->
              <div v-if="currentAction !== 'look'">
                <el-upload
                  :action="`${URL.sys.uploadFileForDocumentTemplate}?uuid=${templateData.uuid}`"
                  :before-upload="beforeUpload"
                  :headers="{sessionId:$store.getters.token}"
                  :show-file-list="false"
                  :on-success="uploadSuccess"
                  :on-error="uploadError"
                  :on-change="toChooseFile"
                  accept=".pdf,.doc,.docx,.xls,.xlsx"
                  style="display: inline-block;margin-right: 5px;"
                >
                  <el-button type="primary">{{ $t('Warehouse.SelectFile') }}</el-button>
                </el-upload>

                <el-button type="danger" @click="delPhotoHandler">{{ $t('Warehouse.DeleteFile') }}</el-button>
              </div>
            </el-form>

            <!-- 文件显示区域 - 查看和编辑时都显示 -->
            <div v-if="templateData.fileName" style="margin-top: 10px; padding: 10px; background: #f5f7fa; border-radius: 4px;">
              <div style="display: flex; align-items: center; gap: 10px;">
                <i class="el-icon-document" style="font-size: 18px; color: #409eff;" />
                <a
                  href="javascript:void(0)"
                  style="font-weight: 500; color: #409eff; text-decoration: none; cursor: pointer; display: inline-block;"
                  @click="downloadFile"
                >
                  {{ templateData.fileName }}
                </a>
                <span style="flex: 1;" />
                <span style="color: #909399; font-size: 12px;">{{ templateData.fileSize }}</span>
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <!-- 日志区域 - 只在查看模式时显示 -->
      <div v-if="isLook" class="section" style="width:100%; height:auto;">
        <span class="title">{{ $t('CargoMsg.Cargo_Log') }}</span>
        <div class="form-row grid-list">
          <cargo-ag-grid
            ref="logGrid"
            config-module="9300005"
            :grid-options="logGridOptions"
            :column-defs="logColumnDefs"
            :row-data="logData"
            @gridReady="params=>{logGridApi=params.api}"
          />
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { basicCacheKeys as selectTypeNames } from '@/utils/cacheConfig'
import { deleteFile } from '@/api/storage'
import {
  addDocumentTemplate,
  editDocumentTemplate,
  getDocumentTemplateDetail,
  batchDeleteDocumentTemplate,
  batchUpdateDocumentTemplateStatus
} from '@/api/sysManage/documentTemplateManagement'
import { getLoading4Cxt, getLoading } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getDocCategoryTypeTree } from '@/api/sysManage/baseConfig/docCategory'
import { sortByMultiField } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'DocumentTemplateWorkspace',
  components: { cargoAdvanceSelect, cargoCompanySelect },
  props: {
    parentContext: {
      type: Object,
      required: true
    },
    rowData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      URL, // 添加URL到data中使其在模板中可访问
      currentAction: 'look',
      currentFileHash: '', // 当前上传文件的hash值
      templateData: {
        uuid: '',
        templateName: '',
        templateType: '',
        localTemplateName: '',
        applicableCarrierId: '',
        applicableToSeaportCode: '',
        templateDescription: '',
        localTemplateDescription: '',
        dateModified: '',
        documentId: '',
        fileName: '',
        fileSize: '',
        fileHash: '',
        status: 0,
        updateVersion: false
      },
      // 临时字段用于页面展示
      tempData: {
        applicableCarrierIdArray: [],
        applicableToSeaportCodeArray: []
      },
      logData: [],
      // 级联选择器配置
      cascaderProps: {
        value: 'path', // 使用path作为value，确保唯一性
        label: 'displayName', // 使用处理后的显示名称
        children: 'childNods',
        checkStrictly: false, // 只允许选择叶子节点
        emitPath: false // 直接返回选中节点的path值
      },
      // 模板类型树形数据（从后端动态加载）
      templateTypeTreeData: [],
      // 日志相关数据
      logGridApi: null,
      logGridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        domLayout: 'autoHeight'
      },
      logColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Time'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperateBy'),
          field: 'createdBy',
          colId: 'createdBy',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: 'action',
          colId: 'action',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.actionLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.UploadFile'),
          field: 'fileName',
          colId: 'fileName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FileSize'),
          field: 'fileSize',
          colId: 'fileSize',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VersionNo'),
          field: 'logVersion',
          colId: 'logVersion',
          width: 100,
          cellRenderer: (params) => {
            return params.value === 0 ? '' : params.value
          }
        }
      ]
    }
  },
  computed: {
    selectTypeNames() {
      return selectTypeNames
    },
    isEdit() {
      return this.currentAction === 'edit'
    },
    isLook() {
      return this.currentAction === 'look'
    },
    // 启用按钮是否禁用
    isEnableDisabled() {
      return this.templateData.status === SystemConstants.DOCUMENT_TEMPLATE_ENABLE.code
    },
    // 禁用按钮是否禁用
    isDisableDisabled() {
      return this.templateData.status === SystemConstants.DOCUMENT_TEMPLATE_DISABLE.code
    },
    // 删除按钮是否禁用
    isDeleteDisabled() {
      return this.templateData.status === SystemConstants.DOCUMENT_TEMPLATE_ENABLE.code
    }
  },
  mounted() {
  },
  methods: {
    onShow(action, rowData, row) {
      this.currentAction = action
      this.loadTemplateTypeTreeData()
      if (action === 'add') {
        this.currentAction = 'add'
        this.resetForm()
        this.templateData = {
          uuid: '',
          templateName: '',
          templateType: '',
          localTemplateName: '',
          applicableCarrierId: '',
          applicableToSeaportCode: '',
          templateDescription: '',
          localTemplateDescription: '',
          dateModified: '',
          documentId: '',
          fileName: '',
          fileSize: '',
          fileHash: '',
          status: 0,
          updateVersion: false
        }
        // 初始化临时字段
        this.tempData = {
          applicableCarrierIdArray: [],
          applicableToSeaportCodeArray: []
        }
      } else if (row && row.uuid) {
        // 加载详情数据
        this.loadTemplateDetail(row.uuid)
      }
    },

    // 加载模板详情数据
    async loadTemplateDetail(uuid) {
      const loading = getLoading4Cxt(this)
      // 调用后端详情接口
      const response = await getDocumentTemplateDetail(uuid).finally(() => loading.close())
      this.doLoadList(response)
    },
    doLoadList(response) {
      if (response && response.data) {
        const data = response.data
        // 映射后端字段到前端数据结构
        this.templateData = {
          uuid: data.uuid || '',
          templateName: data.templateName || '',
          templateType: data.templateType || '',
          localTemplateName: data.localTemplateName || '',
          applicableCarrierId: data.applicableCarrierId || '',
          applicableToSeaportCode: data.applicableToSeaportCode || '',
          templateDescription: data.templateDescription || '',
          localTemplateDescription: data.localTemplateDescription || '',
          version: data.version || '',
          dateModified: data.dateModified || '',
          documentId: data.documentId || '',
          fileName: data.fileName || '',
          fileSize: data.fileSize || '',
          fileHash: data.fileHash || '',
          status: data.status || 0,
          updateVersion: data.updateVersion || false
        }

        // 将原字段转换为临时字段用于页面展示
        this.tempData = {
          applicableCarrierIdArray: this.parseToArray(data.applicableCarrierId),
          applicableToSeaportCodeArray: this.parseToArray(data.applicableToSeaportCode)
        }

        // 加载日志数据
        if (data.documentTemplateManagementLogs && data.documentTemplateManagementLogs.length > 0) {
          this.logData = data.documentTemplateManagementLogs
            .map(log => ({
              action: log.action || '',
              dateCreated: log.dateCreated || '',
              createdBy: log.createdBy || '',
              fileName: log.fileName || '',
              fileSize: log.fileSize,
              logVersion: log.logVersion || ''
            }))
            .sort((a, b) => {
              // 按时间倒序排列（最新的在前面）
              const dateA = new Date(a.dateCreated)
              const dateB = new Date(b.dateCreated)
              return dateB - dateA
            })
        } else {
          this.logData = []
        }

        // 确保templateType使用正确的path值以便级联选择器正确显示
        this.$nextTick(() => {
          if (this.templateData.templateType) {
            const templateTypePath = this.convertTemplateTypeToPath(this.templateData.templateType)
            if (templateTypePath) {
              this.templateData.templateType = templateTypePath
            }
          }
          this.$forceUpdate()
        })
      }
    },

    // 获取状态标签
    getStatusLabel(status) {
      return ColumnUtils.actionLabelFunction(status)
    },

    // 将后端数据转换为数组格式
    parseToArray(value) {
      if (!value) return []
      if (Array.isArray(value)) return value
      if (typeof value === 'string') {
        // 如果是逗号分隔的字符串，转换为数组，并转换为数字类型
        return value.split(',').filter(item => item.trim()).map(item => {
          const num = Number(item.trim())
          return isNaN(num) ? item.trim() : num
        })
      }
      // 如果是单个值，转换为数组
      const num = Number(value)
      return [isNaN(num) ? value : num]
    },

    // 将数组转换为后端期望的字符串格式
    arrayToString(value) {
      if (!value || !Array.isArray(value)) return ''
      return value.filter(item => item).join(',')
    },

    switchToEdit() {
      this.currentAction = 'edit'
    },
    switchToAdd() {
      this.$emit('add')
    },
    cancelEdit() {
      if (this.templateData.uuid) {
        this.currentAction = 'look'
      } else {
        this.$emit('back', false)
      }
    },

    async saveTemplate() {
      // 必填字段校验
      if (!this.templateData.templateName) {
        this.$message.error(this.$t('Message.pleaseEnterTemplateName'))
        return
      }
      if (!this.templateData.localTemplateName) {
        this.$message.error(this.$t('SystemMaintenance.PleaseEnterLocalTemplateName'))
        return
      }
      if (!this.templateData.templateType || (Array.isArray(this.templateData.templateType) && this.templateData.templateType.length === 0)) {
        this.$message.error(this.$t('Information.PleaseSelectTemplateType'))
        return
      }
      // 文件必填校验
      if (!this.templateData.fileName || !this.templateData.documentId) {
        this.$message.error(this.$t('CargoMsg.Cargo_PleaseSelectFile'))
        return
      }

      if (!this.templateData.uuid) {
        const loading = getLoading4Cxt(this)
        const saveData = { ...this.templateData }
        // 将临时字段转换为后端期望的格式
        saveData.applicableCarrierId = this.arrayToString(this.tempData.applicableCarrierIdArray)
        saveData.applicableToSeaportCode = this.arrayToString(this.tempData.applicableToSeaportCodeArray)
        // 确保templateType是完整的path格式（逗号分隔的UUID序列）
        // saveData.templateType 保持原值（完整的path）
        const response = await addDocumentTemplate(saveData).finally(() => {
          loading.close()
        })
        this.$message.success(this.$t('Message.SaveSucceed'))
        this.currentAction = 'look'
        // 使用响应数据更新当前模板数据并通知父组件
        if (response && response.data) {
          this.doLoadList(response)
        }
        this.$emit('refresh', response.data)
      } else {
        const loading = getLoading4Cxt(this)
        const saveData = { ...this.templateData }
        // 将临时字段转换为后端期望的格式
        saveData.applicableCarrierId = this.arrayToString(this.tempData.applicableCarrierIdArray)
        saveData.applicableToSeaportCode = this.arrayToString(this.tempData.applicableToSeaportCodeArray)
        // 将完整的path传递给后端，确保唯一性
        // saveData.templateType 保持原值（完整的path）
        const response = await editDocumentTemplate(saveData).finally(() => {
          loading.close()
        })
        this.$message.success(this.$t('Message.SaveSucceed'))
        this.currentAction = 'look'
        // 使用响应数据更新当前模板数据并通知父组件
        if (response && response.data) {
          this.doLoadList(response)
        }
        this.$emit('refresh', response.data)
      }
    },
    // 下载文件
    downloadFile() {
      if (this.templateData.documentId) {
        const downloadUrl = `${URL.common.findByFileId}/${this.templateData.documentId}?sessionId=${this.$store.getters.userInfo.sessionId}`
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = this.templateData.fileName || 'download'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    toChooseFile(file) {
      if (file.size > 5 * 1024 * 1024) {
        this.$message.warning(this.$t('CargoMsg.FileBeLargerThan5MB'))
        return
      }
    },
    // 文件选择前的处理
    async beforeUpload(file) {
      try {
        // 计算文件hash
        const fileHash = await this.calculateFileHash(file)
        this.currentFileHash = fileHash
        return true
      } catch (error) {
        this.$message.error('文件处理失败')
        return false
      }
    },
    // 计算文件hash值
    calculateFileHash(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          try {
            const arrayBuffer = e.target.result
            // 使用Web Crypto API计算SHA-256 hash
            crypto.subtle.digest('SHA-256', arrayBuffer).then(hashBuffer => {
              const hashArray = Array.from(new Uint8Array(hashBuffer))
              const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
              resolve(hashHex)
            }).catch(reject)
          } catch (error) {
            reject(error)
          }
        }
        reader.onerror = () => reject(new Error('文件读取失败'))
        reader.readAsArrayBuffer(file)
      })
    },

    // 上传成功
    uploadSuccess(response, file, fileList) {
      // 检查响应是否表示成功
      if (response && response.ok === false) {
        // 服务器返回错误响应
        let errorMessage = ''
        if (response.errors && response.errors.length > 0) {
          errorMessage = response.errors[0].message
        } else if (response.message) {
          errorMessage = response.message
        }
        this.$message.error(errorMessage)
        return
      }
      if (response && response.data) {
        const newFileHash = this.currentFileHash || ''
        const oldFileHash = this.templateData.fileHash || ''

        this.templateData.documentId = response.data.documentId
        this.templateData.fileName = response.data.fileName
        // 转换文件大小单位
        this.templateData.fileSize = this.formatFileSize(response.data.fileSize)

        // 版本号管理
        if (this.currentAction === 'add') {
          this.templateData.fileHash = newFileHash
          this.templateData.updateVersion = true
        } else if (this.currentAction === 'edit') {
          // 编辑时，如果文件hash发生变更则版本号+1
          if (newFileHash && newFileHash !== oldFileHash) {
            this.templateData.fileHash = newFileHash
            this.templateData.updateVersion = true
          }
        }
        // 清除临时hash
        this.currentFileHash = ''
      }
    },

    // 上传错误处理
    uploadError(err, file, fileList) {
      let errorMessage = ''
      // 尝试解析错误响应
      if (err && err.response) {
        try {
          const response = JSON.parse(err.response)
          if (response.errors && response.errors.length > 0) {
            errorMessage = response.errors[0].message
          } else if (response.message) {
            errorMessage = response.message
          }
        } catch (e) {
          // 解析失败，使用默认错误信息
        }
      }
      this.$message.error(errorMessage)
    },

    // 格式化文件大小，将B转换为合适的单位
    formatFileSize(sizeInB) {
      if (!sizeInB || sizeInB === 0) {
        return ''
      }
      const size = Number(sizeInB)
      if (isNaN(size) || size <= 0) {
        return ''
      }
      if (size < 1024) {
        return `${size.toFixed(0)} B`
      } else if (size < 1024 * 1024) {
        return `${(size / 1024).toFixed(2)} KB`
      } else if (size < 1024 * 1024 * 1024) {
        return `${(size / (1024 * 1024)).toFixed(2)} MB`
      } else {
        return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`
      }
    },
    // 删除文件
    async delPhotoHandler() {
      if (!this.templateData.documentId) {
        return
      }
      const success = await deleteFile(this.templateData.documentId).then(res => res.data)
      if (success !== 'success') {
        this.$message.warning(this.$t('queryJob.failedDeleteFile'))
        return
      }
      this.templateData.documentId = ''
      this.templateData.fileName = ''
      this.templateData.fileSize = ''
      this.templateData.fileHash = ''
    },
    // 启用
    enableFunction() {
      this.$confirm(this.$t('SystemMaintenance.TemplateEnabledPrompt', [this.templateData.templateName, this.templateData.localTemplateName]), this.$t('CargoMsg.Cargo_Enable'), {
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        confirmButtonText: this.$t('CargoMsg.Cargo_ConfirmR'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const loading = getLoading()
        batchUpdateDocumentTemplateStatus({
          uuids: [this.templateData.uuid],
          status: SystemConstants.DOCUMENT_TEMPLATE_ENABLE.code
        }).then(resp => {
          this.$message.success(this.$t('SystemMaintenance.EnabledSuccessfully'))
          // 更新当前数据状态
          this.templateData.status = SystemConstants.DOCUMENT_TEMPLATE_ENABLE.code
          // 通知父组件刷新
          this.$emit('refresh', this.templateData)
        }).catch(() => {
        }).finally(() => loading.close())
      })
    },

    // 禁用
    disableFunction() {
      this.$confirm(this.$t('SystemMaintenance.TemplateDisabledPrompt', [this.templateData.templateName, this.templateData.localTemplateName]), this.$t('CargoMsg.Cargo_Disable'), {
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        confirmButtonText: this.$t('CargoMsg.Cargo_Disable'),
        confirmButtonClass: 'el-button--danger',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const loading = getLoading()
        batchUpdateDocumentTemplateStatus({
          uuids: [this.templateData.uuid],
          status: SystemConstants.DOCUMENT_TEMPLATE_DISABLE.code
        }).then(resp => {
          this.$message.success(this.$t('SystemMaintenance.DisabledSuccessfully'))
          // 更新当前数据状态
          this.templateData.status = SystemConstants.DOCUMENT_TEMPLATE_DISABLE.code
          // 通知父组件刷新
          this.$emit('refresh', this.templateData)
        }).catch(() => {
        }).finally(() => loading.close())
      })
    },

    // 删除
    deleteFunction() {
      this.$confirm(this.$t('SystemMaintenance.TemplateDeletedPrompt', [this.templateData.templateName, this.templateData.localTemplateName]), this.$t('CargoMsg.Cargo_OrderDelete'), {
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        confirmButtonText: this.$t('CargoMsg.Cargo_OrderDelete'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const loading = getLoading()
        batchDeleteDocumentTemplate([this.templateData.uuid]).then(resp => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          // 通知父组件刷新并返回列表
          this.$emit('refresh')
          this.$emit('back', false)
        }).catch(() => {
          this.$message.error(this.$t('CargoMsg.Cargo_DeleteFailed'))
        }).finally(() => {
          loading.close()
        })
      }).catch(() => {
        // 用户取消删除操作，不需要处理
      })
    },
    resetForm() {
      if (this.$refs.templateForm) {
        this.$refs.templateForm.resetFields()
      }
    },

    // 处理模板类型级联选择器变化
    handleTemplateTypeChange(value) {
      // value现在直接是path字符串
      if (value) {
        this.templateData.templateType = value
      } else {
        // 清空选择
        this.templateData.templateType = ''
      }
    },

    // 处理后端返回的树形数据，添加显示名称
    processTreeData(data) {
      return data.map(item => {
        const processedItem = { ...item }

        // 根据系统语言环境选择显示名称
        // 如果是中文环境，优先显示中文名称，否则显示英文名称
        const isChineseLocale = this.$store.getters.language === 'zh'
        if (isChineseLocale) {
          processedItem.displayName = item.chineseName || item.englishName || item.code
        } else {
          processedItem.displayName = item.englishName || item.chineseName || item.code
        }

        // 递归处理子节点
        if (item.childNods && item.childNods.length > 0) {
          processedItem.childNods = this.processTreeData(item.childNods)
        }

        return processedItem
      })
    },

    customerIdFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return (item.seaCmp || item.airCmp) && item.active
    },

    // 从后端获取模板类型树形数据
    async loadTemplateTypeTreeData() {
      const loading = getLoading4Cxt(this)
      await getDocCategoryTypeTree().then(res => {
        const sortedDetails = sortByMultiField(res.data, ['level', 'type', 'code', 'chineseName'], false)
        // 先构建树形结构，再处理显示名称
        const treeData = this.buildTreeStructure(sortedDetails)
        this.templateTypeTreeData = this.processTreeData(treeData)

        // 如果已有templateType值，确保使用正确的path值
        this.$nextTick(() => {
          if (this.templateData.templateType && typeof this.templateData.templateType === 'string') {
            const templateTypePath = this.convertTemplateTypeToPath(this.templateData.templateType)
            if (templateTypePath) {
              this.templateData.templateType = templateTypePath
            }
          }
        })
      }).finally(() => {
        loading.close()
      })
    },

    // 将平铺数据构建为树形结构 - 基于path构建
    buildTreeStructure(flatData) {
      const pathMap = {}
      const roots = []

      // 去重处理 - 根据path去重
      const uniqueData = []
      const seenPaths = new Set()

      flatData.forEach(item => {
        if (!seenPaths.has(item.path)) {
          seenPaths.add(item.path)
          uniqueData.push(item)
        }
      })

      // 创建路径映射表
      uniqueData.forEach(item => {
        pathMap[item.path] = { ...item, childNods: [] }
      })

      // 基于path构建树形结构
      uniqueData.forEach(item => {
        const node = pathMap[item.path]
        const pathParts = item.path.split(',')

        if (pathParts.length === 1) {
          // 第一级，作为根节点
          roots.push(node)
        } else {
          // 多级，找到父节点path
          const parentPath = pathParts.slice(0, -1).join(',')
          const parentNode = pathMap[parentPath]

          if (parentNode) {
            // 找到父节点，添加到父节点的children中
            parentNode.childNods.push(node)
          } else {
            // 找不到父节点，可能是数据问题，作为根节点处理
            roots.push(node)
          }
        }
      })

      // 清理空的childNods，避免显示空的展开箭头
      this.cleanEmptyChildren(roots)

      return roots
    },

    // 清理空的子节点数组，确保只展示到第三级
    cleanEmptyChildren(nodes) {
      nodes.forEach(node => {
        const pathParts = node.path ? node.path.split(',') : []

        // 如果是第三级节点，清空子节点，使其成为叶子节点
        if (pathParts.length >= 3) {
          delete node.childNods
        } else if (node.childNods && node.childNods.length > 0) {
          // 递归清理子节点
          this.cleanEmptyChildren(node.childNods)
        }
      })
    },

    // 确保templateType是正确的path格式，用于级联选择器回显
    convertTemplateTypeToPath(templateTypeValue) {
      if (!templateTypeValue || !this.templateTypeTreeData) {
        return null
      }

      // 如果传入的是path值（包含逗号），直接返回
      if (templateTypeValue.includes(',')) {
        return templateTypeValue
      }

      // 如果传入的是单个uuid，需要查找对应的完整path
      const findPathByUuid = (nodes, targetUuid) => {
        for (const node of nodes) {
          if (node.uuid === targetUuid) {
            return node.path
          }

          if (node.childNods && node.childNods.length > 0) {
            const result = findPathByUuid(node.childNods, targetUuid)
            if (result) {
              return result
            }
          }
        }
        return null
      }

      return findPathByUuid(this.templateTypeTreeData, templateTypeValue)
    },

    // 辅助方法：在树形数据中查找指定UUID的节点
    findNodeByUuid(nodes, targetUuid) {
      for (const node of nodes) {
        if (node.uuid === targetUuid) {
          return node
        }
        if (node.childNods && node.childNods.length > 0) {
          const result = this.findNodeByUuid(node.childNods, targetUuid)
          if (result) {
            return result
          }
        }
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.document-template-workspace {
  height: calc(100vh - 120px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;

  // 自定义滚动条样式
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;

    &:hover {
      background: #a8a8a8;
    }
  }

  .spacing {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .grid-list {
    flex-direction: row;
    width: 100%;
    max-width: 100%;
    min-width: 1200px;
  }

  .section {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 20px;

    &:last-child {
      margin-bottom: 5px;
    }

    .title {
      display: inline-block;
      position: relative;
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
      padding-left: 15px;
      line-height: 20px;
    }

    .title:before {
      content: '';
      position: absolute;
      width: 4px;
      top: 0;
      left: 0;
      bottom: 0;
      background-color: #1F75D5;
    }

    .form-row {
      &.grid-list {
        ::v-deep .ag-theme-alpine {
          min-height: 200px;
          max-height: 500px;
          height: auto;
          border: 1px solid #e6ebf5;
          border-radius: 4px;

          .ag-header {
            background-color: #fafafa;
            border-bottom: 1px solid #e6ebf5;
          }

          .ag-header-cell-label {
            font-weight: 500;
            color: #606266;
          }

          .ag-row {
            &:hover {
              background-color: #f5f7fa;
            }
          }
        }
      }
    }
  }

  // 四列布局样式优化
  ::v-deep .el-form-item {
    margin-bottom: 8px;

    .el-form-item__label {
      font-size: 13px;
      color: #606266;
      font-weight: normal;
      padding-right: 8px;
    }

    .el-form-item__content {
      line-height: 28px;
      flex: 1;
    }
  }

  ::v-deep .el-input--small .el-input__inner {
    height: 28px;
    line-height: 28px;
  }

  ::v-deep .el-textarea--small .el-textarea__inner {
    padding: 4px 8px;
  }

  ::v-deep .el-cascader--small {
    line-height: 28px;
  }

  ::v-deep .el-date-editor--small.el-input {
    width: 100%;
  }

  // 确保输入框撑满容器
  ::v-deep .el-input,
  ::v-deep .el-cascader,
  ::v-deep .el-date-editor,
  ::v-deep .cargo-advance-select,
  ::v-deep .cargo-company-select {
    width: 100% !important;
  }

  // 确保行间距合适
  .el-row {
    margin-bottom: 10px;
  }
}
</style>
